import React from "react";
import { domainData } from "./Data";
import { Row, Col } from "react-bootstrap";
import "./DomainResults.css";

function CreateDomainCard(props) {
  return (
    <Col md={6} lg={4}>
      <div className="ei-domain-card">
        <div className="domain-img">
          <img src={props.src} alt="" />
        </div>
        <div className="domain-name" style={{borderBottom: "5px solid " + props.color}}>{props.domainName}</div>
        <div className="domain-desc">{props.desc}</div>
        <div className="domain-result">
          <p>
            Your scores suggest <strong>{props.result}</strong> level in this
            domain.
          </p>
        </div>
      </div>
    </Col>
  );
}

function DomainResults(props) {
  if (props.selfAwareness >= 52 && props.selfAwareness <= 70) {
    domainData[0]["color"] = "#99d199";
    domainData[0]["result"] = "a high";
  } else if (props.selfAwareness >= 33 && props.selfAwareness <= 51) {
    domainData[0]["color"] = "#f3e355";
    domainData[0]["result"] = "an average";
  } else if (props.selfAwareness >= 14 && props.selfAwareness <= 32) {
    domainData[0]["color"] = "#f87979";
    domainData[0]["result"] = "a below average";
  }

  if (props.managingEmotions >= 52 && props.managingEmotions <= 70) {
    domainData[1]["color"] = "#99d199";
    domainData[1]["result"] = "a high";
  } else if (props.managingEmotions >= 33 && props.managingEmotions <= 51) {
    domainData[1]["color"] = "#f3e355";
    domainData[1]["result"] = "an average";
  } else if (props.managingEmotions >= 14 && props.managingEmotions <= 32) {
    domainData[1]["color"] = "#f87979";
    domainData[1]["result"] = "a below average";
  }

  if (props.motivatingOneself >= 38 && props.motivatingOneself <= 50) {
    domainData[2]["color"] = "#99d199";
    domainData[2]["result"] = "a high";
  } else if (props.motivatingOneself >= 24 && props.motivatingOneself <= 37) {
    domainData[2]["color"] = "#f3e355";
    domainData[2]["result"] = "an average";
  } else if (props.motivatingOneself >= 10 && props.motivatingOneself <= 23) {
    domainData[2]["color"] = "#f87979";
    domainData[2]["result"] = "a below average";
  }

  if (props.empathy >= 23 && props.empathy <= 30) {
    domainData[3]["color"] = "#99d199";
    domainData[3]["result"] = "a high";
  } else if (props.empathy >= 14 && props.empathy <= 22) {
    domainData[3]["color"] = "#f3e355";
    domainData[3]["result"] = "an average";
  } else if (props.empathy >= 6 && props.empathy <= 13) {
    domainData[3]["color"] = "#f87979";
    domainData[3]["result"] = "a below average";
  }

  if (props.handlingRelationships >= 59 && props.handlingRelationships <= 80) {
    domainData[4]["color"] = "#99d199";
    domainData[4]["result"] = "a high";
  } else if (
    props.handlingRelationships >= 38 &&
    props.handlingRelationships <= 58
  ) {
    domainData[4]["color"] = "#f3e355";
    domainData[4]["result"] = "an average";
  } else if (
    props.handlingRelationships >= 16 &&
    props.handlingRelationships <= 37
  ) {
    domainData[4]["color"] = "#f87979";
    domainData[4]["result"] = "a below average";
  }

  return (
    <div>
      <Row>{domainData.map(CreateDomainCard)}</Row>
    </div>
  );
}

export default DomainResults;
